import React, { Component } from 'react';
import './styles.scss';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import {
    Link
} from "react-router-dom";
import functionCommon from "../../core/common/function";

class Error extends Component {
    render() {
        const homeLink = functionCommon.requireAuth() ? '/login' : '/update-working-hour';
        const { t, number, text } = this.props;
        const error = JSON.parse(localStorage.getItem('msgError'));
        localStorage.removeItem('msgError');
        return (
            <div className="error-content">
                <h1 className="page-title">{number}</h1>
                <p className="sub-title">{text}</p>
                {error &&  
                    <>
                        <p className="error-title">Error: </p>
                            {error.map((item) => {
                            return (
                                <p className="error">{item}</p>
                            )
                        })}
                    </>
                }
                <p className="notice">{t('error.notice')}</p>
                <Link className="ui large fluid button" to={homeLink}>{t('common.homePage')}</Link>
            </div>
        );
    }
}

export default compose(
    withTranslation()
)(Error);
